import React from 'react';

import find from 'lodash/find';

import {SimpleItemPickerListPopoverRTK} from 'app/general/widgets/SimpleItemPickerList';
import {useAddUserToRole} from 'app/roles/api';
import {convertLocationParamsToFetchParams, useUsers} from 'app/user/api';
import {gt} from 'app/utils/i18n';

import type {OverlayProps} from 'app/general/overlays';
import type {RoleSerializedType, UserSerializedType} from 'sweet-types';

type Props = {
  overlayProps: OverlayProps;
  role: RoleSerializedType;
};

export function AddRoleMemberPopover({overlayProps, role}: Props) {
  // RTK API Hooks
  const [addUserToRole] = useAddUserToRole();

  const getUserItemProps = (user: UserSerializedType) => ({
    disabledText:
      find(role.role_memberships, {
        user: {
          url: user.url,
        },
      }) != null
        ? gt('Already a role member')
        : undefined,
  });

  const addUsersToRole = (users: Array<UserSerializedType>) => {
    for (let i = 0; i < users.length; i += 1) {
      addUserToRole({user: users[i], role});
    }
  };

  return (
    <SimpleItemPickerListPopoverRTK
      showDescription={false}
      overlayProps={overlayProps}
      additionalParams={{
        exclude_role: role.id,
        exclude_guests: '1',
      }}
      useDataHook={useUsers}
      paramsConverter={convertLocationParamsToFetchParams}
      addItemProps={getUserItemProps}
      onConfirm={addUsersToRole}
      searchPlaceholder={gt('Search all team members')}
      isPopover={true}
      isSmall={true}
    />
  );
}
